import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FileType} from '../../../shared/types/file/file-type';
import {SecurityService} from '../../../shared/services/security/security.service';
import {SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'wsd-organization-reporting',
  templateUrl: './organization-reporting.component.html',
  styleUrls: ['./organization-reporting.component.css']
})
export class OrganizationReportingComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  canEditFiles: boolean;

  annualReportYear: number;
  annualStatementYear: number;

  annualReportYears: SelectItem[];
  annualStatementYears: SelectItem[];

  fileTypes = FileType;

  constructor(private security: SecurityService) {
  }

  ngOnInit() {
    this.annualReportYears = this.generateYears(FileType.ANNUAL_REPORT);
    this.annualStatementYears = this.generateYears(FileType.ANNUAL_FINANCIAL_STATEMENT);
    this.security.hasPermission('ORGANIZATION_SUMMARY_NOTE_UPDATE')
      .subscribe((result: boolean) => this.canEditFiles = result);
  }

  annualReportUploaded(file) {
    file.year = this.annualReportYear;
    this.annualReportYear = null;
    this.annualReportYears = this.generateYears(FileType.ANNUAL_REPORT);
  }
  annualStatementUploaded(file) {
    file.year = this.annualStatementYear;
    this.annualStatementYear = null;
    this.annualStatementYears = this.generateYears(FileType.ANNUAL_FINANCIAL_STATEMENT);
  }

  sfhReportUploaded(file) {
    file.year = (new Date()).getFullYear();
  }

  public isSfhReportPresent(): boolean {
    for (const fileInfo of this.parentForm.get('fileInfo').value) {
      if (fileInfo.type === 'SAFE_FROM_HARM_REPORTING') {
        return true;
      }
    }
    return false;
  }

  public isSfhPolicyPresent(): boolean {
    for (const fileInfo of this.parentForm.get('fileInfo').value) {
      if (fileInfo.type === 'SAFE_FROM_HARM_POLICY') {
        return true;
      }
    }
    return false;
  }

  private generateYears(fileType: FileType): SelectItem[] {
    const files = this.parentForm.get('fileInfo').value;

    const existingYears = files.map(f => {
      return f.type === fileType && f.year;
    }).filter(Boolean);

    return [{label: '', value: ''}].concat(
      // @ts-ignore
      _.range(moment().year() - 1,  2000 - 1).map(
        year => {
          return !existingYears.includes(year) && {label: year, value: year};
        }
      ).filter(Boolean)
    );
  }

  get fileInfo() { return this.parentForm.get('fileInfo').value; }
}
